import { $ as e, A as t, C as n, F as r, S as i, U as a, h as o, i as s, m as c, nt as l, ot as u, q as d, rt as f, t as p, v as m, w as h } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as g, t as _ } from "./i18n-lite-BcmwMblk.js";
import { t as v } from "./normalize-props-DNjMoRjC.js";
import { t as y } from "./shadow-dom-9FbsLIC0.js";
import { n as b, t as x } from "./Icon.ce-CkLZiCcP.js";
import { n as S, t as C } from "./Modal.ce-CIjVVUkd.js";
//#region src/webcomponents/generate-mdp/locales/de-AT.json
var w = {}, T = {}, E = {}, D = {}, O = {}, k = { "generate-mdp": {
	addPassword: "Ajouter un mot de passe",
	title: {
		label: "Titre",
		value: "La belle fripe"
	},
	email: {
		label: "Adresse mail",
		value: "elio@pixmail.org"
	},
	password: "Mot de passe",
	save: "Enregistrer",
	strength: "Fort",
	weak: "Faible",
	generatePassword: "Générer un mot de passe fort",
	feedback: {
		title: "Bravo !",
		content: "Grâce au gestionnaire de mots de passe, vous pouvez générer automatiquement des mots de passe forts."
	}
} }, A = {}, j = {}, M = "data:image/svg+xml,%3csvg%20width='18'%20height='18'%20viewBox='0%200%2018%2018'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.99976%2011.25V12.75M4.49976%2015.75H13.4998C13.8976%2015.75%2014.2791%2015.592%2014.5604%2015.3107C14.8417%2015.0294%2014.9998%2014.6478%2014.9998%2014.25V9.75C14.9998%209.35218%2014.8417%208.97064%2014.5604%208.68934C14.2791%208.40804%2013.8976%208.25%2013.4998%208.25H4.49976C4.10193%208.25%203.7204%208.40804%203.4391%208.68934C3.15779%208.97064%202.99976%209.35218%202.99976%209.75V14.25C2.99976%2014.6478%203.15779%2015.0294%203.4391%2015.3107C3.7204%2015.592%204.10193%2015.75%204.49976%2015.75ZM11.9998%208.25V5.25C11.9998%204.45435%2011.6837%203.69129%2011.1211%203.12868C10.5585%202.56607%209.79541%202.25%208.99976%202.25C8.20411%202.25%207.44104%202.56607%206.87844%203.12868C6.31583%203.69129%205.99976%204.45435%205.99976%205.25V8.25H11.9998Z'%20stroke='white'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", N = "data:image/svg+xml,%3csvg%20width='33'%20height='33'%20viewBox='0%200%2033%2033'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M29.562%2016.5C29.562%2019.0835%2028.7959%2021.609%2027.3606%2023.7571C25.9253%2025.9053%2023.8852%2027.5795%2021.4983%2028.5682C19.1115%2029.5568%2016.485%2029.8155%2013.9512%2029.3115C11.4173%2028.8075%209.08976%2027.5634%207.26294%2025.7366C5.43611%2023.9098%204.19203%2021.5822%203.68801%2019.0484C3.18399%2016.5145%203.44267%2013.8881%204.43134%2011.5012C5.42001%209.11434%207.09426%207.07425%209.24238%205.63893C11.3905%204.2036%2013.916%203.4375%2016.4995%203.4375C19.0419%203.43667%2021.5293%204.17778%2023.6566%205.56996C25.784%206.96214%2027.4588%208.94486%2028.4758%2011.275M29.562%207.5625L28.9089%2011.9281L24.7495%2011'%20stroke='white'%20stroke-width='3.09375'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M13.7495%2015.125V13.0625C13.7495%2012.3332%2014.0392%2011.6337%2014.555%2011.118C15.0707%2010.6022%2015.7702%2010.3125%2016.4995%2010.3125C17.2289%2010.3125%2017.9283%2010.6022%2018.4441%2011.118C18.9598%2011.6337%2019.2495%2012.3332%2019.2495%2013.0625V15.125M15.4683%2022.6875H17.5308C19.1436%2022.6875%2019.9508%2022.6875%2020.5049%2022.2613C20.6479%2022.1515%2020.776%2022.0234%2020.8858%2021.8804C21.312%2021.3249%2021.312%2020.5191%2021.312%2018.9062C21.312%2017.2934%2021.312%2016.4862%2020.8858%2015.9321C20.776%2015.7891%2020.6479%2015.661%2020.5049%2015.5513C19.9494%2015.125%2019.1436%2015.125%2017.5308%2015.125H15.4683C13.8554%2015.125%2013.0483%2015.125%2012.4941%2015.5513C12.3511%2015.661%2012.223%2015.7891%2012.1133%2015.9321C11.687%2016.4876%2011.687%2017.2934%2011.687%2018.9062C11.687%2020.5191%2011.687%2021.3263%2012.1133%2021.8804C12.223%2022.0234%2012.3511%2022.1515%2012.4941%2022.2613C13.0496%2022.6875%2013.8554%2022.6875%2015.4683%2022.6875Z'%20stroke='white'%20stroke-width='3.09375'%20stroke-linejoin='round'/%3e%3c/svg%3e", P = { class: "wrapper" }, F = ["aria-level"], I = ["src"], L = { class: "password-field" }, R = { class: "password-strength" }, z = {
	"aria-live": "polite",
	class: "password-strength__strengthness"
}, B = { class: "sr-only" }, V = ["src"], H = /*#__PURE__*/ p(/* @__PURE__ */ h({
	__name: "GenerateMdp.ce",
	props: { titleLevel: {
		default: 2,
		type: Number
	} },
	setup(s, { expose: p }) {
		let { t: h } = g(), _ = a("success-modal"), v = e(h("generate-mdp.title.value")), w = e(h("generate-mdp.email.value")), T = e(""), E = e(!1);
		async function D() {
			E.value = !0, await t(), _.value.dialogElement.focus();
		}
		y();
		function O() {
			E.value = !1, T.value = "";
		}
		let k = [
			"39m%,Yqp4brJ",
			"aqN1^!T`:GID",
			"4_nakXe59Hi5",
			"l]`G&nP:U3b7",
			"2Hkl!Qr%8oBf",
			"@[3LE.t%fqNa",
			"RU:ttJ~fCi1R",
			"-(1JRS[bxe4e",
			"<AXKB)1c=H{I",
			"]hFo+`(Pb4H6",
			"JeQSL1Gdo9[%",
			"R()BD|m0OYcv",
			"m<E)0lA5f-QR",
			"nh4j_GsB9@p+",
			"I+W+>2Y%VCDe",
			"6h,kMeN|_K>3",
			":rK!Fy`^3c&i",
			"1^E|Zlgc1+nq",
			"QJ09r]Bxdb#E",
			",2G+Gj<pk:fD",
			"*D4W0asv+$:("
		];
		function A() {
			let e = Math.floor(k.length * Math.random());
			T.value = k[e];
		}
		let j = c(() => k.includes(T.value) ? h("generate-mdp.strength") : h("generate-mdp.weak"));
		return p({ reset: O }), (e, t) => (r(), m("div", P, [o("div", {
			"aria-level": s.titleLevel,
			class: "title",
			role: "heading"
		}, [n(x, { "background-color": "#2c75ff" }, {
			default: d(() => [o("img", {
				src: l(M),
				alt: ""
			}, null, 8, I)]),
			_: 1
		}), i(" " + u(e.$t("generate-mdp.addPassword")), 1)], 8, F), o("form", null, [
			n(S, {
				modelValue: v.value,
				"onUpdate:modelValue": t[0] ||= (e) => v.value = e,
				label: e.$t("generate-mdp.title.label"),
				readonly: !0,
				type: "text"
			}, null, 8, ["modelValue", "label"]),
			n(S, {
				modelValue: w.value,
				"onUpdate:modelValue": t[1] ||= (e) => w.value = e,
				label: e.$t("generate-mdp.email.label"),
				readonly: !0,
				type: "text"
			}, null, 8, ["modelValue", "label"]),
			o("div", L, [
				n(S, {
					modelValue: T.value,
					"onUpdate:modelValue": t[2] ||= (e) => T.value = e,
					label: e.$t("generate-mdp.password"),
					readonly: !0,
					class: "password",
					type: "text"
				}, null, 8, ["modelValue", "label"]),
				o("div", R, [
					o("p", z, [o("span", B, u(e.$t("generate-mdp.password")) + "\xA0", 1), i(u(j.value), 1)]),
					o("div", {
						class: f([{ "filled-strength": T.value !== "" }, "password-strength__step"]),
						"aria-hidden": "true"
					}, null, 2),
					o("div", {
						class: f([{ "filled-strength": T.value !== "" }, "password-strength__step"]),
						"aria-hidden": "true"
					}, null, 2),
					o("div", {
						class: f([{ "filled-strength": T.value !== "" }, "password-strength__step"]),
						"aria-hidden": "true"
					}, null, 2)
				]),
				n(b, {
					title: e.$t("generate-mdp.generatePassword"),
					variant: "primary-bis",
					onClick: A
				}, {
					default: d(() => [o("img", {
						src: l(N),
						alt: ""
					}, null, 8, V)]),
					_: 1
				}, 8, ["title"])
			]),
			n(b, {
				class: "send",
				"is-disabled": !T.value,
				onClick: D
			}, {
				default: d(() => [i(u(e.$t("generate-mdp.save")), 1)]),
				_: 1
			}, 8, ["is-disabled"]),
			n(C, {
				ref: "success-modal",
				content: e.$t("generate-mdp.feedback.content"),
				show: E.value,
				loop: !1,
				title: e.$t("generate-mdp.feedback.title")
			}, null, 8, [
				"content",
				"show",
				"title"
			])
		])]));
	}
}), [["styles", ["*{--text-blue:#122647;--background-blue:#253858;box-sizing:border-box;font-family:Nunito,Roboto,sans-serif;font-size:14px}h1,h2,h3,h4,h5,h6{color:var(--text-blue);font-family:Nunito,sans-serif}h2{color:var(--text-blue);font-size:20px}p,a,span,li{color:var(--text-blue);font-family:Roboto,sans-serif}button{background:var(--background-blue);border-radius:8px;font-size:16px;font-weight:700}button:disabled{background:#c8cfd9}input{background:#f4f5f7;border:#cdd1d9;border-radius:10px}.sr-only{clip-path:inset(50%);white-space:nowrap;border:0;width:1px;height:1px;padding:0;position:absolute;overflow:hidden}html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video,dialog{font-size:100%;font:inherit;vertical-align:baseline;border:0;margin:0;padding:0}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}table{border-collapse:collapse;border-spacing:0}*{color:#253858}", ".wrapper[data-v-cee41612]{background:#fff;border-radius:14px;padding:25px;position:relative;box-shadow:0 2px 5px #4a3aff40,inset 0 -2px 5px #4a3aff26,inset 0 1px 1px #ffffff1a,inset 0 3px 4px #dfeeff1a}[data-v-cee41612] label{margin-top:16px}.title[data-v-cee41612]{align-items:center;gap:8px;font-size:1.25rem;font-weight:700;display:flex}.password-field[data-v-cee41612]{grid-template-columns:1fr 1fr 45px;gap:0 16px;display:grid}.password-field .password-strength[data-v-cee41612]{grid-column:2/span 2;justify-self:end;align-items:center;gap:8px;display:flex}.password-field .password-strength__step[data-v-cee41612]{background:#c8cfd9;border-radius:5px;width:40px;height:5px}.password-field .password-strength__strengthness[data-v-cee41612]{color:#5e6c84;font-family:Roboto;font-size:14px;font-style:normal;font-weight:400}.password-field .password-strength .filled-strength[data-v-cee41612]{background:#54c590}.password-field[data-v-cee41612] input{grid-area:2/1/auto/span 2}.password-field button[data-v-cee41612]{justify-content:center;width:45px;height:45px;display:flex}.send[data-v-cee41612]{margin:16px auto 0;display:block}@media screen and (width<=576px){.password-field[data-v-cee41612]{grid-template-columns:1fr 1fr 45px;grid-column:unset;display:grid}.password-field[data-v-cee41612] .password{grid-row:unset}.password-field .password-strength[data-v-cee41612]{grid-column:unset;grid-row:3/span 2;justify-self:start;margin-top:8px}}"]], ["__scopeId", "data-v-cee41612"]]);
//#endregion
//#region src/webcomponents/generate-mdp/generate-mdp.ce.js
_.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": w,
	"./locales/en.json": T,
	"./locales/es-419.json": E,
	"./locales/es.json": D,
	"./locales/fr-BE.json": O,
	"./locales/fr.json": k,
	"./locales/it.json": A,
	"./locales/nl.json": j
}));
var U = s(H, { configureApp(e) {
	_.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(_);
} });
U.prototype.normalizeProps = (e) => ({ titleLevel: v(e.titleLevel) }), window.customElements.define("generate-mdp", U);
//#endregion
